import { Action, ThunkDispatch, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import agentCopilotAccessSlice from "./agentCopilotAccessSlice";
import agentCopilotApi from "./apis/agentCopilotApi";
import callTranslatorApi from "./apis/callTranslatorApi";
import configurationSlice from "./configurationSlice";

export function createStore(apiBaseUrl: string, token: string) {
  const store = configureStore({
    reducer: {
      [agentCopilotAccessSlice.name]: agentCopilotAccessSlice.reducer,
      [configurationSlice.name]: configurationSlice.reducer,
      [agentCopilotApi.reducerPath]: agentCopilotApi.reducer,
      [callTranslatorApi.reducerPath]: callTranslatorApi.reducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(
      agentCopilotApi.middleware,
      callTranslatorApi.middleware,
    ),
    preloadedState: getPreloadedState(apiBaseUrl, token),
  });

  setupListeners(store.dispatch);

  return store;
}

type StoreType = ReturnType<typeof createStore>;
export type RootState = ReturnType<StoreType["getState"]>;

export type AppDispatch = ThunkDispatch<RootState, unknown, Action>;
export const useAppDispatch = () => useDispatch<AppDispatch>();

function getPreloadedState(apiBaseUrl: string, token: string) {
  const decodedToken = token
    ? jwtDecode<{ sub: string; tenant: string }>(token)
    : { sub: "", tenant: "" };

  return {
    [configurationSlice.name]: {
      apiBaseUrl,
      token,
      agentId: decodedToken.sub,
      tenantId: decodedToken.tenant,
    },
  };
}
